import { app } from '../../../../../app';
import { Controller } from './dropbox-sync-settings.controller';

app.component('dropboxSyncSettings', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./dropbox-sync-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-sync-settings/dropbox-sync-settings.component.js